import { StyledDivider } from './BookingStageDivider.styles';

export const BookingStageDivider = ({
  isAccepted,
}: {
  isAccepted: boolean;
}) => {
  return <StyledDivider isAccepted={isAccepted} />;
};

export default BookingStageDivider;
